export const getUniqueNameFile = (nombreBase, archivos) => {
	const nombres = archivos.map((obj) => obj.nombre);
	// Separar nombre base y extensión
	const extensionIndex = nombreBase.lastIndexOf('.');
	const tieneExtension = extensionIndex !== -1;
	const nombreSinExtension = tieneExtension
		? nombreBase.substring(0, extensionIndex)
		: nombreBase;
	const extension = tieneExtension ? nombreBase.substring(extensionIndex) : '';

	function eliminarUltimoParentesisAntesExtension(cadena) {
		const puntoIndex = cadena.lastIndexOf('.');
		if (puntoIndex === -1) return cadena; // No tiene extensión
		const antesDelPunto = cadena.substring(0, puntoIndex);
		const despuesDelPunto = cadena.substring(puntoIndex);
		// Eliminar el último grupo (...) justo antes del punto
		const antesModificado = antesDelPunto.replace(/\s*\([^()]*\)\s*$/, '');
		return antesModificado.trim() + despuesDelPunto;
	}

	let maxSufijo = 0;
	let nombreBaseExiste = false;
	nombres.forEach((nombre) => {
		let replaceName = eliminarUltimoParentesisAntesExtension(nombre);
		if (replaceName === nombreBase) {
			nombreBaseExiste = true;
			maxSufijo = maxSufijo + 1;
		}
	});
	if (!nombreBaseExiste) {
		return nombreBase;
	}
	return `${nombreSinExtension}(${maxSufijo + 1})${extension}`;
};
